import {
    LIST_RESEARCH_FAILURE,
    LIST_RESEARCH_SUCCESS,
    SET_RESEARCHES_IS_LOADING,
} from './actionTypes';
import { listResearchesAPI } from '../api/researchAPI';

function listResearchSuccess(data) {
    return { data, type: LIST_RESEARCH_SUCCESS };
}

function listResearchFailure(response) {
    return { response, type: LIST_RESEARCH_FAILURE };
}

export function listResearches(offset) {
    return dispatch => listResearchesAPI(offset)
        .then(response => dispatch(listResearchSuccess(response.data)))
        .catch(response => dispatch(listResearchFailure(response)));
}

export function setResearchesIsLoadingTrue() {
    return dispatch => dispatch({ type: SET_RESEARCHES_IS_LOADING });
}
